import { Ikon, type IkonNamn } from "./Ikon";

// Fakturans väg genom produkten. Används på startsidan och i appen.
export const STEG: [string, string, IkonNamn][] = [
  ["Mottagning", "PDF, bild eller e-faktura via Peppol, e-post eller uppladdning.", "inbox"],
  ["Avläsning", "AI läser leverantör, belopp, moms, betalväg, referens och rader. Osäkra fält markeras.", "scan"],
  ["Kontroller", "Ett 40-tal kontroller: leverantör, betalväg, moms, dubbletter, risk och påminnelser.", "shield"],
  ["Kontering", "Konto och kostnadsställe hämtas från order, referens, regel, leverantör eller historik.", "ledger"],
  ["Överlämning", "Röd till handläggning. Gul och grön till attest, med det som ska bekräftas utpekat.", "handoff"],
  ["Attest", "Personalen attesterar. Agenten attesterar och betalar aldrig själv.", "sign"],
];

export function Flode({ banor = true }: { banor?: boolean }) {
  return (
    <>
      {banor ? (
        <div className="lanes" aria-hidden="true"><span className="lane agentl">Agenten</span><span className="lane pers">Personalen</span></div>
      ) : null}
      <ol className="flode" aria-label="Fakturans väg">
        {STEG.map(([namn, text, ikon], i) => (
          <li key={namn} className={"fsteg" + (i === 4 ? " acc" : i === 5 ? " human" : "")}>
            <div className="top2"><span className="ico"><Ikon namn={ikon} /></span><span className="n">{String(i + 1).padStart(2, "0")}</span></div>
            <b>{namn}</b>
            <p>{text}</p>
          </li>
        ))}
      </ol>
    </>
  );
}

type Siffror = { rod: number; gul: number; gron: number };
const UT: ["rod" | "gul" | "gron", string, string, string][] = [
  ["rod", "Röd", "Handläggning", "Stoppas med orsaken angiven. Till exempel annan betalväg än registret, meddelanden om nya bankuppgifter, konto som saknas eller påminnelse utan original."],
  ["gul", "Gul", "Attest med kontrollpunkter", "Går till attest. Attestanten bekräftar det agenten pekar på. Saknas betalvägen i registret blir fakturan gul med betalspärr."],
  ["gron", "Grön", "Klar för attest", "Allt stämmer. Är leverantören känd och fakturan matchar en order kan den godkännas av regel."],
];

export function Utfall({ siffror }: { siffror?: Siffror }) {
  const tot = siffror ? siffror.rod + siffror.gul + siffror.gron : 0;
  const sv = (n: number) => n.toLocaleString("sv-SE");
  const visa = siffror && tot ? siffror : null;
  return (
    <div className="utfallblock">
      {visa ? (
        <>
          <div className="dist" role="img" aria-label={`Fördelning: röd ${sv(visa.rod)}, gul ${sv(visa.gul)}, grön ${sv(visa.gron)} av ${sv(tot)}`}>
            {UT.map(([c]) => (visa[c] ? <span key={c} className={c} style={{ flex: visa[c] }} /> : null))}
          </div>
          <div className="distl" aria-hidden="true"><span>0</span><span>{sv(tot)} fakturor</span></div>
        </>
      ) : null}
      <div className="utfall">
        {UT.map(([c, farg, titel, p]) => (
          <article key={c} className="ufall" style={{ ["--c" as string]: `var(--${c})` }}>
            <span className="lab"><i />{farg}</span>
            {visa ? <div className="tal"><b>{sv(visa[c])}</b><span>st · {Math.round((visa[c] / tot) * 100)} %</span></div> : null}
            <h3>{titel}</h3>
            <p>{p}</p>
          </article>
        ))}
      </div>
    </div>
  );
}

const B: { t: string; c?: "gul" | "gron"; tag?: string; lock?: boolean }[] = [
  { t: "Betalvägen saknas i registret" },
  { t: "Gul med betalspärr", c: "gul", tag: "betalspärr", lock: true },
  { t: "Konteras och attesteras som vanligt", tag: "attest fortsätter", lock: true },
  { t: "Ekonomi verifierar via känd kontaktväg", lock: true },
  { t: "Spärren hävs och fakturan betalas", c: "gron", tag: "betalas" },
];

// Stegen när betalvägen saknas. kort=true ger egen kortram med rubrik (startsidan).
export function Betalsparr({ kort = false }: { kort?: boolean }) {
  const lista = (
    <ol className="sbana">
      {B.map((s) => (
        <li key={s.t} className={[s.c, s.lock ? "lockseg" : ""].filter(Boolean).join(" ") || undefined}>
          <span className="node">{s.c === "gul" ? <Ikon namn="lock" /> : s.c === "gron" ? <Ikon namn="unlock" /> : <i className="pt" />}</span>
          <span className="lbl">{s.t}{s.tag ? <span className={"tag" + (s.c ? " " + s.c : "")}>{s.tag}</span> : null}</span>
        </li>
      ))}
    </ol>
  );
  if (!kort) return lista;
  return <div className="track"><h4>När betalvägen saknas i registret</h4>{lista}</div>;
}
